"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeAgreementOverrides = void 0;
var lodash_1 = require("lodash");
var mergeAgreementOverrides = function (acceptSettings, overrides) {
    var incomingSettings = (0, lodash_1.cloneDeep)(acceptSettings);
    if (incomingSettings.button) {
        incomingSettings.button.customLabel = overrides.buttonText;
    }
    else {
        incomingSettings.button = {
            custom: false,
            customLabel: overrides.buttonText,
            customCompletionText: "Congratulations! The quote has been accepted.",
        };
    }
    return incomingSettings;
};
exports.mergeAgreementOverrides = mergeAgreementOverrides;
